import React, { useEffect, useState,useRef } from 'react';
import { Link, useNavigate,useLocation,useSearchParams } from "react-router-dom";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

function CGPAToPercent() {
    const [cgpa, setCGPA] = useState('');
    const [percentage, setPercentage] = useState('');

    const calculatePercentage = () => {
        if (cgpa === '') {
            alert('Please enter a CGPA value');
            return;
        }
        if(cgpa>10){
            alert('enter valid cgpa!')
            return;
        }
        if(cgpa<0){
            alert('enter valid cgpa!')
            return; 
        }
        const calculatedPercentage = ((parseFloat(cgpa)-0.5 )* 10).toFixed(2);
        setPercentage(calculatedPercentage);
    };

// useEffect(
//     ()=>{
//         const ele=document.getElementById("cgpaInput");
//         const driverObj = driver({
//             popoverClass: 'driverjs-theme',
//         });
//     if(ele){
//         ele.addEventListener("focus", () => {
//             driverObj.highlight({
//               element: '#cgpaInput',
//               popover: {
//                 title: "CGPA",
//                 description: "<b>Enter</b> <i>your</i> CGPA here",
//               },
//             });
//           });
    
//         }
    
//     },[]

// )



    return (
        <div className="container">
            <div className="converter-container mt-5 p-4 border " style={{backgroundColor:"#fff"}}>
                <h2 className="mb-4">CGPA to % Converter</h2>
                <div className="mb-3">
                    <label htmlFor="cgpaInput" className="form-label">Enter your CGPA:</label>
                    <input type="number" step="0.01" min="0" max="10" className="form-control" id="cgpaInput" value={cgpa} onChange={(e) => setCGPA(e.target.value)}  />
                </div>
                <button className="btn btn-primary" onClick={calculatePercentage}>Calculate Percentage</button>
                {percentage && <div className="mt-3">Your percentage is: <b>{percentage}</b>%</div>}
            </div>

        </div>
    );
}

export default CGPAToPercent;


function TourGuide(){

    const location = useLocation();
    const driverObjRef = useRef(null);
  
  
    useEffect(() => {
  
  
  const driverObj = driver({
    // showProgress: true,
    allowClose: true,
  // overlayColor: '#47d3ceab',
      popoverClass: 'driverjs-theme',
      showButtons: ['next', 'previous','close'],
  
    steps: [
      { element: '.intro-block', popover: { title: 'Quick Start Guide', description: 'Learn how to use GPA converter...', side: "right", align: 'center' } },
      { element: '#drop-menu', popover: { title: 'Dropdown Menu', description: 'Helps to navigate to pages' } },
      { element: '#card1', popover: { title: 'CGPA to %', description: 'This tool will convert your cgpa to percentage. click on <b>Calculate</b> button to continue' } },
      { element: '#card2', popover: { title: 'Grade to SGPA', description: 'This tool will convert your Grades into SGPA. click on <b>Calculate</b> button to continue' } },
      { element: '#card3', popover: { title: 'CGPA Calculator', description: 'This tool will calculate your CGPA from total Grade points. click on <b>Calculate</b> button to continue' } },
    ],
  
    onDestroyStarted: () => {
      if (!driverObj.hasNextStep()) {
        
        if(localStorage.isnewuser){
          localStorage.setItem('isnewuser','false');
        }
        
        driverObj.destroy();
      }
    },
  
    onCloseClick:() => {
  
  if(Number(localStorage.countsclick)>=2){
      if(localStorage.isnewuser){
        localStorage.setItem('isnewuser','false');
      }
    }
      driverObj.destroy();
  
      localStorage.setItem('countsclick',Number(localStorage.countsclick)+1);
      console.log(Number(localStorage.countsclick));
   
    },
  
  
    
  });
  driverObjRef.current = driverObj;
  
  if(!localStorage.isnewuser){
    localStorage.setItem('isnewuser','true');
  }
  
  if(!localStorage.countsclick){
    localStorage.setItem('countsclick','0');
  }
  
  if(localStorage.isnewuser=="true"){
    driverObj.drive();
  }
  
  
  
  return () => {
    if (driverObjRef.current) {
      driverObjRef.current.destroy(); 
    }
  };
  }, [location.pathname]);
  
    return(
        <>
        
        </>
    )
}